export var SnapshotReason;
(function (SnapshotReason) {
    SnapshotReason["peak_time"] = "peak_time";
    SnapshotReason["triggered"] = "triggered";
    SnapshotReason["scheduled"] = "scheduled";
    SnapshotReason["testing"] = "testing";
})(SnapshotReason || (SnapshotReason = {}));
//# sourceMappingURL=SnapshotReason.enum.js.map